'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.addLinkCrosshairsWidget = function (mapEditorModel) {
	return mmWidgets.each(this, function () {
		const element = this;
		mapEditorModel.addEventListener('context', function (context) {
			if (context.addLinkMode) {
				element.addClass('mapjs-add-link');
			} else {
				element.removeClass('mapjs-add-link');
			}
		});
	});
};


